import { toastHelper } from '../../../util/toastHelper'
import ButtonCustom from '../../atoms/button/ButtonCustom'
import InputCustom from '../../atoms/input/InputCustom'
import styles from '../user/user.module.scss'
import GoogleAddressInput from '../../atoms/input/GoogleAddressInput'

const PlannerInfo = ({ userDetails, setUserDetails, setRole, setStep }) => {
	const handlePlaceSelected = (placeData) => {
		setUserDetails({
			...userDetails,
			businessAddress: placeData.formattedAddress,
		})
	}

	const handleSubmit = async (e) => {
		e.preventDefault()
		const { firstName, lastName, businessName, businessAddress } =
			userDetails

		if (
			!firstName.trim() ||
			!lastName.trim() ||
			!businessName.trim() ||
			!businessAddress.trim()
		) {
			return toastHelper('Please fill out all fields', 'error')
		}
		setUserDetails((prev) => ({
			...prev,
			businessTypes: ['Wedding Planner'],
			role: 'kazoo-planner',
		}))
		setStep((s) => s + 1)
	}

	return (
		<>
			<div className={styles.uploadContainer}>
				<p className={styles.semiHeading}>Tell us about your business</p>
				{/* Profile picture upload */}
				<div
					className={styles.uploadContainer}
					style={{ marginTop: '24px' }}
				>
					<label
						htmlFor="profileUpload"
						className={styles.uploadCircle}
						style={{ margin: '0 auto' }}
					>
						{userDetails.profilePic ? (
							<img
								src={userDetails.profilePic}
								alt="Profile"
								className={styles.profileImage}
							/>
						) : (
							<span>
								Upload
								<br />A Photo
							</span>
						)}
						<div className={styles.cameraIcon}>📷</div>
					</label>
					<input
						id="profileUpload"
						type="file"
						accept=".jpg, .png"
						style={{ display: 'none' }}
						onChange={(e) => {
							const file = e.target.files[0]
                            if (file) {
                                setUserDetails({
                                    ...formData,
                                    containsImage: 'profilePic',
                                    images: [file],
                                })
                            }
						}}
					/>
				</div>
				<form className={styles.form} onSubmit={handleSubmit}>
					<div className={styles.formGroup}>
						<InputCustom
							data-cy="firstName"
							placeholder="First Name"
							name="firstName"
							type="text"
							value={userDetails.firstName}
							setDataFunction={setUserDetails}
							data={userDetails}
							required={true}
						/>
					</div>

					<div className={styles.formGroup}>
						<InputCustom
							data-cy="lastName"
							name="lastName"
							placeholder="Last Name"
							type="text"
							value={userDetails.lastName}
							setDataFunction={setUserDetails}
							data={userDetails}
							required={true}
						/>
					</div>

					<div className={styles.formGroup}>
						<InputCustom
							data-cy="businessName"
							placeholder="Business Name"
							name="businessName"
							type="text"
							value={userDetails.businessName}
							setDataFunction={setUserDetails}
							data={userDetails}
							required={true}
						/>
					</div>

					<div className={styles.formGroup}>
						<GoogleAddressInput
							data-cy="businessAddress"
							placeholder="Business Address"
							name="businessAddress"
							value={userDetails.businessAddress}
							setDataFunction={setUserDetails}
							data={userDetails}
							onPlaceSelected={handlePlaceSelected}
							required={true}
						/>
					</div>

					<div
						className={`${styles.bottomButtons} ${styles.skipBtn}`}
					>
						<button
							data-cy="backbutton"
							onClick={() => setRole('')}
							className="backButton"
						>
							Back
						</button>
						<ButtonCustom className={styles.button} type="submit">
							Next
						</ButtonCustom>
					</div>
				</form>
			</div>
		</>
	)
}

export default PlannerInfo